export const UNIT_OPTIONS = [
  "Kg", "Grams", "Litres", "Ml", "Pieces", "Packets", "Boxes", "Bags",
  "Bottles", "Cans", "Jars", "Trays", "Plates", "Dozen", "Cartons",
  "Tins", "Pouches", "Bundles", "Sets",
];

export const MENU_UNITS = [
  "KG", "GRAM", "LTR", "ML", "PCS", "PACKET", "BOX", "BAG", "BOTTLE",
  "CAN", "JAR", "TRAY", "PLATE", "DOZEN", "CARTON", "TIN", "POUCH", "BUNDLE", "SET",
];

export const normalizeUnit = (value) => {
  const aliases = {
    kg: "Kg", kgs: "Kg", kilogram: "Kg", kilograms: "Kg",
    g: "Grams", gm: "Grams", gms: "Grams", gram: "Grams", grams: "Grams",
    l: "Litres", lt: "Litres", ltr: "Litres", ltrs: "Litres", litre: "Litres", litres: "Litres", liter: "Litres", liters: "Litres",
    ml: "Ml", millilitre: "Ml", millilitres: "Ml", milliliter: "Ml", milliliters: "Ml",
    pc: "Pieces", pcs: "Pieces", piece: "Pieces", pieces: "Pieces", no: "Pieces", nos: "Pieces", unit: "Pieces", units: "Pieces",
    pkt: "Packets", pkts: "Packets", pack: "Packets", packs: "Packets",
    dz: "Dozen", dozens: "Dozen", ctn: "Cartons",
  };
  const key = String(value || "").trim().toLowerCase();
  return aliases[key] || UNIT_OPTIONS.find((unit) =>
    unit.toLowerCase() === key || unit.toLowerCase().replace(/s$/, "") === key,
  ) || "";
};

export const convertQuantity = (quantity, sourceUnit, targetUnit) => {
  const source = normalizeUnit(sourceUnit);
  const target = normalizeUnit(targetUnit);
  if (!source || !target) throw new Error("Unknown stock unit");
  if (source === target) return Number(quantity);
  const factors = { Kg: ["mass", 1000], Grams: ["mass", 1], Litres: ["volume", 1000], Ml: ["volume", 1], Pieces: ["count", 1], Dozen: ["count", 12] };
  if (factors[source] && factors[target] && factors[source][0] === factors[target][0]) {
    return Number(quantity) * factors[source][1] / factors[target][1];
  }
  throw new Error(`Cannot convert ${source} to ${target}`);
};
